import invariant from '../utils/invariant';

export default () =>
  invariant(
    false,
    '`getScreenConfig` has been replaced with `getScreenOptions`'
  );



// WEBPACK FOOTER //
// ./~/react-navigation/src/routers/getScreenConfigDeprecated.js